import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
  MatSnackBarLabel,
  MatSnackBarActions,
  MatSnackBarAction,
} from '@angular/material/snack-bar';

export interface CopyIdSnackbarData {
  message: string;
  id: string;
}

@Component({
  selector: 'app-copy-id-snackbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
  ],
  template: `
    <div matSnackBarLabel>{{ data.message }}</div>
    <div matSnackBarActions>
      <button
        matButton
        matSnackBarAction
        [attr.aria-label]="'Copy ID ' + data.id"
        (click)="copy()"
      >
        {{ copied() ? 'Copied' : 'Copy ID' }}
      </button>
    </div>
  `,
  styles: `
    :host {
      display: flex;
    }
  `,
})
export class CopyIdSnackbarComponent {
  protected readonly data = inject<CopyIdSnackbarData>(MAT_SNACK_BAR_DATA);
  private readonly clipboard = inject(Clipboard);
  private readonly snackBarRef = inject(MatSnackBarRef);

  protected readonly copied = signal(false);

  copy() {
    this.clipboard.copy(this.data.id);
    this.copied.set(true);
    setTimeout(() => this.snackBarRef.dismiss(), 800);
  }
}
